import { useState } from 'react';

/**
 * EAA-1822: shared "validate on blur, never on keystroke" state for the edit
 * and onboarding forms (ticket rule: "An empty required field is only an
 * error after a save attempt or blur-after-touch — never on first paint").
 *
 * A field's error only renders once EITHER it has been individually blurred
 * (`touch(field)`) OR the whole form had a save/continue attempt
 * (`markAttempted()`) — so typing into a fresh required field never shows red,
 * but tabbing away from it empty does, and so does hitting Save/Tiếp tục with
 * it still empty.
 */
export function useTouchedFields() {
    const [touched, setTouched] = useState<Record<string, boolean>>({});
    const [attempted, setAttempted] = useState(false);

    function touch(field: string) {
        setTouched((prev) => (prev[field] ? prev : { ...prev, [field]: true }));
    }

    function markAttempted() {
        setAttempted(true);
    }

    function reset() {
        setTouched({});
        setAttempted(false);
    }

    function shouldShowError(field: string): boolean {
        return attempted || Boolean(touched[field]);
    }

    return { touch, markAttempted, attempted, reset, shouldShowError };
}
